import React, { Suspense, lazy } from 'react';
import { store } from './store';
import { Provider } from 'react-redux';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import ReactDOM from 'react-dom/client';
import ErrorPage from './Pages/ErrorPage';
import Loading from './Components/Logics/Loading';
import 'bootstrap/dist/css/bootstrap.min.css';


const lazyWithDelay = (importFunction, delay) => {
  return lazy(() =>
    new Promise(resolve => {
      setTimeout(() => resolve(importFunction()), delay);
    })
  );
};

// Lazy load components with a delay
const RootLayout = lazyWithDelay(() => import('./Pages/RootLayout'), 1000);
const HomePage = lazyWithDelay(() => import('./Pages/HomePage'), 1000);
const Dashboard = lazyWithDelay(() => import('./Pages/Dashboard'), 750);
const OneSecondary = lazyWithDelay(() => import('./Pages/OneSecondary'), 750);
const SecondSecondary = lazyWithDelay(() => import('./Pages/SecondSecondary'), 750);
const ThirdSecondary = lazyWithDelay(() => import('./Pages/ThirdSecondary'), 750);
const Statistics = lazyWithDelay(() => import('./Pages/Statistics'), 750);
const VideoAccess = lazyWithDelay(() => import('./Pages/VideoAccess'), 1000);
const VideoWatch = lazyWithDelay(() => import('./Pages/VideoWatch'), 1000);
const EditVideo = lazyWithDelay(() => import('./Pages/EditVideo'), 1000);

const router = createBrowserRouter([{
  path: '/',
  element: (
    <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
      <Loading />
    </article>}>
      <RootLayout />
    </Suspense>
  ),
  errorElement: <ErrorPage />,
  children: [
    {
      path: '/',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <HomePage />
        </Suspense>
      )
    },
    {
      path: '/Dashboard',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <Dashboard />
        </Suspense>
      )
    },
    {
      path: '/OneSecondary',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <OneSecondary />
        </Suspense>
      )
    },
    {
      path: '/OneSecondary/:id',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <VideoAccess />
        </Suspense>
      )
    },
    {
      path: '/SecondSecondary',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <SecondSecondary />
        </Suspense>
      )
    },
    {
      path: '/SecondSecondary/:id',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <VideoAccess />
        </Suspense>
      )
    },
    {
      path: '/ThirdSecondary',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <ThirdSecondary />
        </Suspense>
      )
    },
    {
      path: '/ThirdSecondary/:id',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <VideoAccess />
        </Suspense>
      )
    },
    {
      path: '/Statistics',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <Statistics />
        </Suspense>
      )
    },
    {
      path: '/Statistics/:id',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <VideoAccess />
        </Suspense>
      )
    },
    {
      path: '/VideoWatch',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <VideoWatch />
        </Suspense>
      )
    },
    {
      path: '/videos/edit/:id',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <EditVideo />
        </Suspense>
      )
    }
  ],
},
]);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Auth0Provider
    domain={process.env.REACT_APP_AUTH0_DOMAIN}
    clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
    authorizationParams={{
      redirect_uri: window.location.origin
    }}
  >
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </Auth0Provider>
);